import React, { useState } from "react";
import SettingsTaskModal from "../Modals/settingsTaskModal";
import SignatureSettingsModal from "../Modals/signatureSettingsModal";
import ESignatureModal from "../Modals/eSignatureModal";
import DeleteTaskModal from "../Modals/deleteTaskModal";

const ModalManager = ({
  enhancedMenuArray,
  modalSettingsObj,
  setModalSettingsObj,
  onFieldUpdate,
}) => {
  const [showSettings, setShowSettings] = useState(false);
  const [showSignatureSettings, setShowSignatureSettings] = useState(false);
  const [showESignature, setShowESignature] = useState(false);
  const [selectedFieldForSettings, setSelectedFieldForSettings] =
    useState(null);
  const [currentSignerType, setCurrentSignerType] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [fieldToDelete, setFieldToDelete] = useState(null);

  const handleSettingsClick = (field) => {
    setSelectedFieldForSettings(field);
    if (field.type === "signature" || field.type === "Signature") {
      setShowSignatureSettings(true);
    } else {
      setShowSettings(true);
    }
  };

  const handleCloseSettings = () => {
    setShowSettings(false);
    setSelectedFieldForSettings(null);
  };

  const handleCloseSignatureSettings = () => {
    setShowSignatureSettings(false);
    setSelectedFieldForSettings(null);
  };

  const handleCloseESignature = () => {
    setShowESignature(false);
    setSelectedFieldForSettings(null);
    setCurrentSignerType(null);
  };

  const handleProvideESignature = (field) => {
    setSelectedFieldForSettings(field);
    setShowESignature(true);
  };

  const handleProvideESignatureFromSettings = (field, signerType) => {
    setSelectedFieldForSettings(field);
    setCurrentSignerType(signerType);
    setShowESignature(true);
  };

  const handleDeleteField = (fieldId) => {
    setFieldToDelete(fieldId);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setFieldToDelete(null);
  };

  const confirmDelete = (onDelete) => {
    if (fieldToDelete) {
      onDelete(fieldToDelete);
      handleCloseDeleteModal();
    }
  };

  const updateField = (updatedField) => {
    onFieldUpdate(updatedField);
  };

  const renderModals = (onDelete) => (
    <>
      {showSettings && (
        <SettingsTaskModal
          show={showSettings}
          onHide={handleCloseSettings}
          field={selectedFieldForSettings}
          modalSettingsObj={modalSettingsObj}
          setModalSettingsObj={setModalSettingsObj}
          menuArray={enhancedMenuArray}
          updateField={updateField}
        />
      )}
      {showSignatureSettings && (
        <SignatureSettingsModal
          show={showSignatureSettings}
          onHide={handleCloseSignatureSettings}
          field={selectedFieldForSettings}
          updateField={updateField}
          onProvideESignatureClick={handleProvideESignatureFromSettings}
        />
      )}
      {showESignature && (
        <ESignatureModal
          show={showESignature}
          onHide={handleCloseESignature}
          field={selectedFieldForSettings}
          updateField={updateField}
          onCloseParentModal={handleCloseSignatureSettings}
          signerType={currentSignerType}
        />
      )}
      {showDeleteModal && (
        <DeleteTaskModal
          show={showDeleteModal}
          onHide={handleCloseDeleteModal}
          onDelete={() => confirmDelete(onDelete)}
        />
      )}
    </>
  );

  return {
    handleSettingsClick,
    handleDeleteField,
    handleProvideESignature,
    renderModals,
  };
};

export default ModalManager;
